import React from "react";

export const COPYRIGHT_NOTICE = "© 2026 Richard Sampson. All rights reserved.";

export function CopyrightNotice({
  className = "",
}: {
  className?: string;
}) {
  return (
    <p className={`text-xs text-tertiary ${className}`.trim()}>
      {COPYRIGHT_NOTICE}
    </p>
  );
}
